import moment from 'moment'

/**
 * The time shown in a read receipt, e.g. "Read 10:42 AM", "Read Yesterday",
 * "Read Mon". Shorter than getFormattedDateTime's output because it trails a
 * word and sits under a bubble.
 */
const formatReceiptTime = (dateTime?: string) => {
	if (!dateTime) return ''

	const now = moment()
	const then = moment(dateTime)
	if (!then.isValid()) return ''

	if (then.isSame(now, 'day')) return then.format('LT')
	if (then.isSame(now.clone().subtract(1, 'day'), 'day')) return 'Yesterday'
	if (then.isAfter(now.clone().subtract(7, 'days').startOf('day'))) return then.format('ddd')
	return then.format('M/D/YY')
}

export default formatReceiptTime
